/*
 *
 * Home constants
 *
 */

export const FLUSH_STATE_HOME = 'app/Home/FLUSH_STATE_HOME';